// Import pages and route components
import config from "./../config";
import HomePage from "./home";
import BlockPage from "./block-page";
import BlockOEPage from "./blockoe-page";
import CoachPage from "./coach-page";
import CoachLitePage from "./coach-lite-page";

const pages = [
  {
    menu: false,
    path: "/",
    component: HomePage,
  },
  {
    menu: false,
    path: "/webnotifications",
    component: HomePage,
  },

  {
    menu: false,
    path: "/webnotifications/block-page.jsp",
    component: BlockPage,
  },
  {
    menu: false,
    path: "/webnotifications/blockoe-page.jsp",
    component: BlockOEPage,
  },
  {
    menu: false,
    path: "/webnotifications/coach.jsp",
    component: CoachPage,
    text: "Home",
  },
  {
    menu: false,
    path: "//webnotifications/coach-lite.jsp",
    component: CoachLitePage,
    text: "Home",
  },
];

// Prepend the siteRoot to the paths to handle deployment to a subdirectory.
const ROUTES_PAGES = pages.map((page) => {
  const path =
    page.path?.substr(0, 1) === "/"
      ? config.server.siteRoot + page.path.slice(1)
      : config.server.siteRoot + page.path;
  return { ...page, ...{ path: path } };
});

export default ROUTES_PAGES;
